import React from "react";

export default class Constants {
  static appName = "Meridian Convention Center";
  static successFullySaved = "Saved Successfully";
  static failToSave = "Fail to Save";
  static successfullyDeleted = "Deleted Successfully";
  static failToDelete = "Fail to Delete";
  static successfullyUpdated = "Update Successfully";
  static failToEdit = "Fail to Update";
  static PacakageslimitExceed="3 packages exceeded"
}
